/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import PageTable from './PageTable';
import { Descriptions } from 'antd';
import useSystemSettings from '../../../custom-hooks/useSystemSettings';
import PageModal from './PageModal';
import SelectedReceiptModal from './SelectedReceiptModal';
import IncomingPurchaseInvoiceContext from '../../../contexts/incoming-purchase-invoice-context/IncomingPurchaseInvoiceContext';
import UserContext from '../../../contexts/user-context/UserProvider';
import SelectedReceiptModalProducts from './SelectedReceiptModalProducts';
import { useTranslation } from 'react-i18next';
const SharedIncomingPurchaseInvoice = ({
  allFetchedReceipts,
  withoutReturnBtn = false,
  total,
  reports,
  taxPage,
  selectedPicker,
  flag
}) => {
  const systemSettings = useSystemSettings();
  const { modalOpened, selectedReceiptModalOpened } = useContext(
    IncomingPurchaseInvoiceContext
  );
  const { user } = useContext(UserContext);

  const { t, i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState();
  useEffect(() => {
    setCurrentLang(i18n.language);
  }, [i18n.language]);

  const renderSystemSettings = (obj) => {
    const {
      name,
      phone,
      email,
      addressCode,
      buildingNum,
      streetName,
      district,
      city,
      anotherId,
      country,
      VATRegistrationNumber,
      tax_number,
      postalCode
    } = obj;
    return (
      <div
        style={{
          marginTop: 32
        }}
        className="system-settings-details-wrap"
      >
        <Descriptions title="" bordered column={2}>
          {name && (
            <Descriptions.Item label={t('purchaseInvoiceReport.name')}>
              {name}
            </Descriptions.Item>
          )}
          {phone && (
            <Descriptions.Item label={t('purchaseInvoiceReport.phone')}>
              {phone}
            </Descriptions.Item>
          )}
          {email && (
            <Descriptions.Item label={t('purchaseInvoiceReport.email')}>
              {email}
            </Descriptions.Item>
          )}
          {buildingNum && (
            <Descriptions.Item
              label={t('purchaseInvoiceReport.buildingNumber')}
            >
              {buildingNum}
            </Descriptions.Item>
          )}
          {streetName && (
            <Descriptions.Item label={t('purchaseInvoiceReport.streetName')}>
              {streetName}
            </Descriptions.Item>
          )}
          {district && (
            <Descriptions.Item label={t('purchaseInvoiceReport.district')}>
              {district}
            </Descriptions.Item>
          )}
          {city && (
            <Descriptions.Item label={t('purchaseInvoiceReport.city')}>
              {city}
            </Descriptions.Item>
          )}
          {country && (
            <Descriptions.Item label={t('purchaseInvoiceReport.country')}>
              {country}
            </Descriptions.Item>
          )}
          {postalCode && (
            <Descriptions.Item label={t('purchaseInvoiceReport.postalCode')}>
              {postalCode}
            </Descriptions.Item>
          )}
          {addressCode && (
            <Descriptions.Item label={t('purchaseInvoiceReport.addressCode')}>
              {addressCode}
            </Descriptions.Item>
          )}
          {VATRegistrationNumber && (
            <Descriptions.Item label={t('purchaseInvoiceReport.vatNumber')}>
              {VATRegistrationNumber}
            </Descriptions.Item>
          )}
          {tax_number && (
            <Descriptions.Item label={t('purchaseInvoiceReport.vatNumber')}>
              {tax_number}
            </Descriptions.Item>
          )}
          {anotherId && (
            <Descriptions.Item label={t('purchaseInvoiceReport.anotherId')}>
              {anotherId}
            </Descriptions.Item>
          )}
          {String(total) && (
            <Descriptions.Item label={t('purchaseInvoiceReport.totalPrice')}>
              {total}
              {t('purchaseInvoiceReport.sar')}
            </Descriptions.Item>
          )}
          {/* {String(allFetchedReceipts?.total) && (
            <Descriptions.Item label="السعر الإجمالى">
              {allFetchedReceipts?.total} ريـــال
            </Descriptions.Item>
          )} */}
        </Descriptions>
      </div>
    );
  };
  const handleData = (user) => {
    if (allFetchedReceipts) {
      if (user === 1) {
        return allFetchedReceipts?.data;
      } else if (user === 2) {
        return allFetchedReceipts;
      }
    }
  };

  const handleModal = (user) => {
    if (user === 1) {
      return <SelectedReceiptModalProducts />;
    } else if (user === 2) {
      return <SelectedReceiptModal />;
    }
  };

  return (
    <>
      {withoutReturnBtn &&
        systemSettings &&
        renderSystemSettings(systemSettings)}
      <div className="PageTable-wrapper">
        <PageTable
          withoutReturnBtn={withoutReturnBtn}
          allFetchedReceipts={allFetchedReceipts}
          reports={reports}
          taxPage={taxPage}
          selectedPicker={selectedPicker}
          flag={flag}
          currentLang={currentLang}
        />
      </div>

      {modalOpened && <PageModal />}
      {selectedReceiptModalOpened && handleModal(user.subscriptionType)}
    </>
  );
};

export default SharedIncomingPurchaseInvoice;
